export const services = [
  {
    id: "peinture",
    title: "Peinture intérieure & extérieure",
    description:
      "Murs, plafonds, boiseries et menuiseries : une préparation sérieuse des supports pour une finition nette et durable.",
    tasks: ["Préparation et rebouchage", "Peinture murs & plafonds", "Laques, boiseries, portes", "Papier peint et toile de verre"],
    image: "https://cdn.magicpatterns.com/patterns/generated-images/ee8a62ea-6466-4b07-8103-3ef6cf0bc6c3.jpg",
    alt: "Salon fraîchement repeint en vert sauge et blanc cassé",
  },
  {
    id: "facade",
    title: "Enduits de façade",
    description:
      "Rénovation et protection de vos façades : ravalement, enduits et peintures adaptés au bâti de Seine-et-Marne.",
    tasks: ["Ravalement", "Enduit monocouche & taloché", "Traitement des fissures"],
    image: "https://cdn.magicpatterns.com/patterns/generated-images/d87669ce-facb-46fb-85c1-81e2fd5cfa8f.jpg",
    alt: "Façade de maison rénovée avec un enduit couleur crème",
  },
  {
    id: "vitrerie",
    title: "Vitrerie",
    description:
      "Remplacement de vitres cassées, pose de vitrages et remise en état de fenêtres, portes vitrées et verrières.",
    tasks: ["Remplacement de vitrage", "Mastic et joints", "Double vitrage"],
    image: "https://cdn.magicpatterns.com/patterns/generated-images/32c47108-908d-4e5e-bb03-6330f9c311b4.jpg",
    alt: "Artisan posant une vitre dans un châssis de fenêtre en bois",
  },
];

export const steps = [
  {
    title: "Vous décrivez votre projet",
    text: "Par téléphone ou via le formulaire : type de travaux, surfaces, délais souhaités.",
  },
  {
    title: "Visite et devis gratuit",
    text: "Je me déplace pour mesurer, conseiller sur les matériaux et vous remettre un devis détaillé.",
  },
  {
    title: "Préparation et travaux",
    text: "Protection des sols et du mobilier, préparation des supports, puis application soignée.",
  },
  {
    title: "Réception du chantier",
    text: "Nous faisons le tour ensemble. Le chantier est rendu propre, sans retouche oubliée.",
  },
];
